import {
  ActionIcon,
  Avatar,
  Button,
  Flex,
  Modal,
  PinInput,
  Select,
  Switch,
  TextInput,
} from "@mantine/core";
import Container from "../components/common/Container";
import styled from "styled-components";
import { FormPanel } from "../components/common/Form/FormRow";
import { useRef, useState } from "react";
import { terminalRegistration } from "../api/terminalApi";
import { useAuth } from "../context/AuthContext";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { errorNotification } from "../utils/useNotification";
import { validateRequired } from "../utils/validations";
import { useNavigate } from "react-router";
import { formatTerminalCode } from "../utils/textUtils";
import PageHeader from "../components/common/PageHeader";
import PlusIcon from "../components/common/Icons/PlusIcon";
import {
  CRL_AGE_DESCRIPTION,
  CRL_AGE_OPTIONS,
  DEFAULT_CRL_AGE_HOURS,
} from "../utils/crlAge";

const NewTablet = () => {
  const { company } = useAuth();
  const navigate = useNavigate();
  const [validationKey, setValidationKey] = useState();
  const [opened, { open, close }] = useDisclosure(false);
  const formRef = useRef<HTMLFormElement>(null);

  const [autoControl, setAutoControl] = useState(false);

  const form = useForm({
    initialValues: {
      name: "",
      terminalCode: "",
      location: "",
      code: company?.code,
      maxCrlAgeHours: String(DEFAULT_CRL_AGE_HOURS),
    },
    validate: {
      name: validateRequired,
      terminalCode: validateRequired,
      location: validateRequired,
    },
  });

  const handleSubmit = async (values: object) => {
    try {
      const { maxCrlAgeHours, ...rest } = values as any;
      const result: any = await terminalRegistration({
        companyCode: company?.code,
        ...rest,
        autoControl,
        // Backend integer bekliyor; Select string veriyor.
        maxCrlAgeHours: Number(maxCrlAgeHours),
      });
      if (result?.data?.success) {
        open();
        setValidationKey(result.data?.validationKey);
      } else {
        errorNotification({
          title: "Terminal Ekleme Hatası",
          message: result.response.data.message,
        });
      }
    } catch (error) {
      console.error("Error generating key:", error);
    }
  };

  return (
    <Container>
      <PageHeader
        pageTitle="Yeni Tablet Kaydı"
        subText="Lütfen aşağıdaki alanları doldurduktan sonra ‘Şifre Oluştur’ butonuna
      basarak üretilecek olan doğrulama şifresini tabletinize giriniz."
        isButtoned
        buttonText="Şifre Oluştur"
        buttonIcon={<PlusIcon />}
        buttonOnClick={() => formRef.current?.requestSubmit()}
      />
      <Flex direction={"column"} gap={40} w={"100%"}>
        <StyledForm ref={formRef} onSubmit={form.onSubmit(handleSubmit)}>
          <TextInput
            label="Şirket Kodu"
            value={company?.code}
            radius={10}
            size="md"
            readOnly
            {...form.getInputProps("code")}
          />
          <TextInput
            label="Tablet İsmi"
            placeholder="İsim"
            radius={10}
            size="md"
            {...form.getInputProps("name")}
          />
          <TextInput
            label="Terminal Kodu"
            placeholder="Terminal Kodu"
            radius={10}
            size="md"
            {...form.getInputProps("terminalCode")}
            onChange={(event) => {
              form.setFieldValue(
                "terminalCode",
                formatTerminalCode(event?.target?.value)
              );
            }}
          />
          <TextInput
            label="Tablet Konumu"
            placeholder="Konum"
            radius={10}
            size="md"
            {...form.getInputProps("location")}
          />
          <Switch
            label="Otomatik açılsın mı?"
            description="Kapalıysa mobil uygulamada giriş/çıkış manuel onayı gerektirir"
            size="md"
            radius={10}
            checked={autoControl}
            onChange={(e) => setAutoControl(e.currentTarget.checked)}
          />
          <Select
            label="Çevrimdışı erişim süresi"
            description={CRL_AGE_DESCRIPTION}
            data={CRL_AGE_OPTIONS}
            radius={10}
            size="md"
            allowDeselect={false}
            {...form.getInputProps("maxCrlAgeHours")}
          />
        </StyledForm>
      </Flex>

      <StyledModal
        radius={20}
        size={"35rem"}
        withCloseButton={false}
        centered
        pos={"relative"}
        opened={opened}
        onClose={close}
        padding={"80px 86px 80px 86px"}
      >
        <ActionIcon
          onClick={close}
          bg={"none"}
          style={{ position: "absolute", top: "20px", right: "20px" }}
        >
          <Avatar src={"/assets/closeIcon.png"} size={24} radius={0} />
        </ActionIcon>
        <Flex
          pos={"relative"}
          justify={"center"}
          align={"center"}
          style={{
            textAlign: "center",
          }}
          direction="column"
          gap={40}
        >
          <Flex direction={"column"} gap={12}>
            <ModalTitle>Tablet Doğrulama Şifresi</ModalTitle>
            <ModalText>
              Lütfen Aşağıdaki şifreyi tabletinizdeki ilgili alana girerek kayıt
              işlemini tamamlayınız.
            </ModalText>
          </Flex>
          <Flex gap={50}>
            <Flex direction={"column"} gap={5}>
              <ModalInfoTitle>Şirket Kodu</ModalInfoTitle>
              <ModalInfoText>{company?.code}</ModalInfoText>
            </Flex>
            <Flex direction={"column"} gap={5}>
              <ModalInfoTitle>Tablet Kodu</ModalInfoTitle>
              <ModalInfoText>{form.values.terminalCode}</ModalInfoText>
            </Flex>
          </Flex>

          <Flex direction={"column"} gap={12}>
            <StyledPinInput
              readOnly
              style={{ pointerEvents: "none" }}
              value={validationKey || "------"} // Dönen key verisi burada gösteriliyor
              size={50}
              gap={4}
              radius={10}
              length={6}
            />
            {/* <KeySubtext>Geçerlilik Süresi: 01.01.2024</KeySubtext> */}
          </Flex>
        </Flex>
        <Button
          color="#5C26FF"
          style={{
            position: "absolute",
            bottom: "20px",
            right: "20px",
            borderRadius: "10px",
          }}
          onClick={() => {
            navigate(`/tablets`);
          }}
        >
          Tamam
        </Button>
      </StyledModal>
    </Container>
  );
};

export default NewTablet;

const StyledModal = styled(Modal)<any>`
  .mantine-Modal-body {
    padding-top: 80px;
  }
`;

const StyledPinInput = styled(PinInput)<any>`
  .mantine-PinInput-input {
    font-size: 24px;
    color: #5c26ff;
  }
`;

const PageTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 12px;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  color: black;
`;

const TitleSubText = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: #828282;
`;

/* Ortak dar form kabı: sabit genişlik + max-width: 100%. */
const StyledForm = styled(FormPanel)``;

const ModalTitle = styled.label`
  color: black;
  font-size: 24px;
  line-height: 24px;
  font-weight: 600;
`;

const ModalText = styled.label`
  color: #828282;
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
`;

const ModalInfoTitle = styled.label`
  color: black;
  font-size: 16px;
  font-weight: 600;
`;

const ModalInfoText = styled.label`
  color: #828282;
  font-size: 16px;
  font-weight: 400;
`;
